import { AutosuggestDataLayer } from "types/custom";
import { DATA_LAYER_SEARCH_TYPE, DATA_LAYER } from "../utils/constants";

export const setSearchToSessionStorage = (
  asFeature: (typeof DATA_LAYER)[keyof typeof DATA_LAYER],
): void => {
  const data: AutosuggestDataLayer = {
    autosuggest: {
      asUsed: true,
      asFeature,
    },
  };

  sessionStorage.setItem(DATA_LAYER_SEARCH_TYPE, JSON.stringify(data));
};
